import { notify } from '@billy/design-system'
import { trackError } from '@billy/track-error'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import { queryClient } from '../../../../../../../config/queryClient'
import { NotificationKeys } from '../../../../../../../enums/notificationKeys'
import { QueryKeys } from '../../../../../../../enums/queryKeys'
import { updateContactPerson } from '../../../../../../../query-api/contactPerson-query'
import { useContactDetail } from '../../../contexts/contactDetailContext'

export const useUpdateContactPerson = () => {
  const { t } = useTranslation()
  const { contact } = useContactDetail()

  const {
    mutate,
    isLoading: isProcessing,
    ...rest
  } = useMutation(updateContactPerson, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeys.Contact, contact.id])
    },
    onError: (error) => {
      notify({
        id: NotificationKeys.CreateContactPerson,
        message: t('error_saving'),
        variant: 'error',
      })
      trackError(error)
    },
  })

  return { updateContactPerson: mutate, isProcessing, ...rest }
}
